module.exports = function() {
  return new Worker(__webpack_public_path__ + "76105df02cdc4609472e.worker.js");
};